import { useState } from "react";
import { Button } from "../ui/button";
import { useDevices, useRemoveDevice, useRevokeOtherSessions, useUpdateSecuritySettings } from "../../hooks/useSecurity";
import { errorMessage } from "../../hooks/useServers";

const DAY_OPTIONS = [1, 3, 7, 14, 30];

// Sesiones (cuánto duran y cerrar las otras) y dispositivos de confianza (los que no piden el código de 2 pasos durante 30 días).
export function SessionsSection({ status }) {
  const { data: devices } = useDevices(true);
  const update = useUpdateSecuritySettings();
  const remove = useRemoveDevice();
  const revoke = useRevokeOtherSessions();
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const guard = async (action, ok) => {
    setError("");
    setMessage("");
    try {
      const data = await action();
      setMessage(ok(data));
    } catch (e) {
      setError(errorMessage(e, "No se pudo completar."));
    }
  };
  return (
    <div data-testid="sessions-section" className="space-y-4">
      <label className="flex items-center gap-2 text-xs text-muted-foreground">
        Mis sesiones duran
        <select data-testid="session-days" value={status.session_days} onChange={(e) => guard(() => update.mutateAsync({ session_days: Number(e.target.value) }), () => "Guardado. Vale desde tu próximo inicio de sesión.")} className="h-8 rounded-md border border-input bg-background px-2 text-sm text-foreground">
          {[...new Set([...DAY_OPTIONS, status.session_days])].sort((a, b) => a - b).map((d) => <option key={d} value={d}>{d} día{d === 1 ? "" : "s"}</option>)}
        </select>
      </label>
      <Button data-testid="revoke-others" size="sm" variant="outline" disabled={revoke.isPending} onClick={() => guard(() => revoke.mutateAsync(), (d) => `Se cerraron ${d.closed} sesión(es).`)}>Cerrar todas las demás sesiones</Button>
      <div className="space-y-2">
        <p className="text-sm font-medium">Dispositivos de confianza</p>
        {devices && devices.length === 0 && <p data-testid="devices-empty" className="text-xs text-muted-foreground">Ninguno. Al entrar con tu código, marca «Confiar en este dispositivo 30 días».</p>}
        <ul className="space-y-1.5">
          {(devices || []).map((d) => (
            <li key={d.id} data-testid={`device-${d.id}`} className="flex items-center justify-between gap-2 rounded-lg border border-border px-3 py-2 text-sm">
              <span className="min-w-0">
                <span className="block truncate">{d.name}{d.current && <span data-testid="device-current" className="ml-2 rounded-full bg-emerald-500/15 px-2 text-[10px] text-emerald-500">Este dispositivo</span>}</span>
                <span className="block text-[11px] text-muted-foreground">Último uso: {d.last_used} · IP {d.ip} · vence {d.expires}</span>
              </span>
              <Button data-testid={`device-remove-${d.id}`} size="sm" variant="ghost" disabled={remove.isPending} onClick={() => guard(() => remove.mutateAsync(d.id), () => "Dispositivo quitado: volverá a pedir el código.")}>Quitar</Button>
            </li>
          ))}
        </ul>
      </div>
      {message && <p data-testid="sessions-message" className="text-xs text-emerald-500">{message}</p>}
      {error && <p data-testid="sessions-error" className="text-xs text-amber-500">{error}</p>}
    </div>
  );
}
